import { setMainOwnerSelectionDictionary } from 'app/shared/helpers/setMainOwnerSelectionDictionary';

const onOwnerFamilyNameChange = {
  onOwnerFamilyNameChange() {
    setMainOwnerSelectionDictionary();
  },
};

export default onOwnerFamilyNameChange;
